export const resumeUrl: string = 'https://pixelbacon.github.io/resume';

export default resumeUrl;
